module.exports = __webpack_public_path__ + "static/media/image.247d653d.jpg";